export const AVAILABLE_TIMES = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
} as const;

export const AVAILABLE_TIMES_HOURS = {
  [AVAILABLE_TIMES.MORNING]: {
    startTime: '09:00',
    endTime: '12:00',
  },
  [AVAILABLE_TIMES.AFTERNOON]: {
    startTime: '13:00',
    endTime: '17:00',
  },
  [AVAILABLE_TIMES.EVENING]: {
    startTime: '18:00',
    endTime: '22:00',
  },
} as const;

export const HIDDEN_UNTIL_FILTERED_COMPETENCES = [
  'Female',
  'Male',
  'Other',
  'Man',
  'Kvinna',
  'Annan',
];

export type TAvailableTimesHoursKey = keyof typeof AVAILABLE_TIMES_HOURS;
